import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 68px);
  padding: 120px 0 40px;
  margin-top: 68px; /* altura do Navbar fixo */
`;

export const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 10px;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
`;

export const Section = styled.section`
  margin-bottom: 2.5rem;

  h2 {
    font-size: 1.5rem;
    color: #444;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
    margin-bottom: 1rem;
  }

  ul {
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-bottom: 1rem;

    li {
      font-size: 1rem;
      line-height: 1.6;
      color: #666;
      margin-bottom: 0.5rem;
    }
  }
`;
